// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset */
html,
body,
#root {
    height: 100%;
    margin: 0;
    padding: 0;
}


* {
    box-sizing: border-box;
}

/* Common */

.m-w-100{
    max-width: 100px;
}


/* layout */
.layout {
    display: flex;
    height: 100%;
}


/* sidebar */
.sidebar {
    flex: 0 0 auto;
    padding: 1rem;
}

.sidebar-btn {
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem;
    margin: 0;
    cursor: pointer;
    width: 100%;

    word-wrap: break-word;
    display: flex;
    gap: 0.25rem;
    font-size: 14px;
    font-family: inherit;
    border-radius: 8px;
    transition: all 0.3s ease-in-out;
    overflow-wrap: anywhere;
    font-weight: 500;
}

.sidebar-btn .sidebar-label {
    margin: 0;
}

.sidebar-btn:not(:last-child) {
    margin-bottom: 0.5rem;
}

.sidebar-btn.active {
    color: #005cff;
    background-color: #188fff21;
    transition: all 0.3s ease-in-out;
}

.sidebar .sidebar-left {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}




/* Product Section New Wrap */
.product-section {
    height: 100%;
    overflow: auto;
    padding: 0.5rem 0.25rem;
    width: 100%;
}

/* Product Row */
.product-row {
    position: relative;
    overflow: visible;
}

.product-row-inner {
    flex-wrap: nowrap;
    flex-direction: column;
    width: 100%;
    margin: 0;
    scroll-snap-type: x mandatory;
    overflow-x: auto;
    padding: 0.25rem 0;

    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch; /* for smooth scrolling on iOS devices */
}

.product-row-inner::-webkit-scrollbar {
    display: none;
}

.product-row .pd-slide-btn-left,
.product-row .pd-slide-btn-right {
    border: none;
    outline: none;
    background: none;
    margin: 0;
    cursor: pointer;
    /* margin-right: 30px; */
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: #00000030;
    color: white;
    -webkit-tap-highlight-color: transparent;
}

.product-row .pd-slide-btn-left {
    left: 0.25rem;
}

.product-row .pd-slide-btn-right {
    right: 0.25rem;
}

.product-row .pd-slide-btn-left:hover,
.product-row .pd-slide-btn-left:hover {
    box-shadow: 0px 4px 16px #00000010;
}

.product-col {
    scroll-snap-align: start;
    flex: 0 0 auto;
}

/* UI Recommendation Header */

@media (max-width: 576px) {

    .layout {
        display: flex;
        flex-direction: column;
    }

    .sidebar {
        display: flex;
        /* align-items: flex-end; */
        justify-content: space-between;
        padding: 0.5rem;
        flex: 0 0 auto;
        border-bottom: 1px solid #f5f5f5;
        gap: 0.5rem;
    }

    .sidebar .sidebar-left {
        justify-content: center;
        gap: 4px;
    }

    .sidebar-btn {
        font-size: 12px;
        font-weight: 500;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        width: auto;
        flex: 1 1 auto;
    }

    .sidebar-btn:first-child {
        flex: 0 0 auto;
    }

    .sidebar-btn .anticon{
        display: none;
    }

    .sidebar-btn:not(:last-child) {
        margin-bottom: 0;
    }

    .product-section {
        flex: 1 1 auto;
        overflow: auto;
    }

    .product-section .ant-typography {
        display: block;
        width: 100%;
    }

    .product-section .ant-typography strong {
        /* text-align: center; */
        display: block;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assests/css/style.css"],"names":[],"mappings":"AAAA,UAAU;AACV;;;IAGI,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA,WAAW;;AAEX;IACI,gBAAgB;AACpB;;;AAGA,WAAW;AACX;IACI,aAAa;IACb,YAAY;AAChB;;;AAGA,YAAY;AACZ;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,eAAe;IACf,WAAW;;IAEX,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;;;;AAKA,6BAA6B;AAC7B;IACI,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;;IAElB,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;IACpC,uBAAuB;IACvB,iCAAiC,EAAE,wCAAwC;AAC/E;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA,6BAA6B;;AAE7B;;IAEI;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,2BAA2B;QAC3B,8BAA8B;QAC9B,eAAe;QACf,cAAc;QACd,gCAAgC;QAChC,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,wBAAwB;QACxB,cAAc;QACd,WAAW;IACf;AACJ","sourcesContent":["/* Reset */\nhtml,\nbody,\n#root {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n\n* {\n    box-sizing: border-box;\n}\n\n/* Common */\n\n.m-w-100{\n    max-width: 100px;\n}\n\n\n/* layout */\n.layout {\n    display: flex;\n    height: 100%;\n}\n\n\n/* sidebar */\n.sidebar {\n    flex: 0 0 auto;\n    padding: 1rem;\n}\n\n.sidebar-btn {\n    border: none;\n    outline: none;\n    background: none;\n    padding: 0.5rem;\n    margin: 0;\n    cursor: pointer;\n    width: 100%;\n\n    word-wrap: break-word;\n    display: flex;\n    gap: 0.25rem;\n    font-size: 14px;\n    font-family: inherit;\n    border-radius: 8px;\n    transition: all 0.3s ease-in-out;\n    overflow-wrap: anywhere;\n    font-weight: 500;\n}\n\n.sidebar-btn .sidebar-label {\n    margin: 0;\n}\n\n.sidebar-btn:not(:last-child) {\n    margin-bottom: 0.5rem;\n}\n\n.sidebar-btn.active {\n    color: #005cff;\n    background-color: #188fff21;\n    transition: all 0.3s ease-in-out;\n}\n\n.sidebar .sidebar-left {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n\n\n\n/* Product Section New Wrap */\n.product-section {\n    height: 100%;\n    overflow: auto;\n    padding: 0.5rem 0.25rem;\n    width: 100%;\n}\n\n/* Product Row */\n.product-row {\n    position: relative;\n    overflow: visible;\n}\n\n.product-row-inner {\n    flex-wrap: nowrap;\n    flex-direction: column;\n    width: 100%;\n    margin: 0;\n    scroll-snap-type: x mandatory;\n    overflow-x: auto;\n    padding: 0.25rem 0;\n\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch; /* for smooth scrolling on iOS devices */\n}\n\n.product-row-inner::-webkit-scrollbar {\n    display: none;\n}\n\n.product-row .pd-slide-btn-left,\n.product-row .pd-slide-btn-right {\n    border: none;\n    outline: none;\n    background: none;\n    margin: 0;\n    cursor: pointer;\n    /* margin-right: 30px; */\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: #00000030;\n    color: white;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.product-row .pd-slide-btn-left {\n    left: 0.25rem;\n}\n\n.product-row .pd-slide-btn-right {\n    right: 0.25rem;\n}\n\n.product-row .pd-slide-btn-left:hover,\n.product-row .pd-slide-btn-left:hover {\n    box-shadow: 0px 4px 16px #00000010;\n}\n\n.product-col {\n    scroll-snap-align: start;\n    flex: 0 0 auto;\n}\n\n/* UI Recommendation Header */\n\n@media (max-width: 576px) {\n\n    .layout {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .sidebar {\n        display: flex;\n        /* align-items: flex-end; */\n        justify-content: space-between;\n        padding: 0.5rem;\n        flex: 0 0 auto;\n        border-bottom: 1px solid #f5f5f5;\n        gap: 0.5rem;\n    }\n\n    .sidebar .sidebar-left {\n        justify-content: center;\n        gap: 4px;\n    }\n\n    .sidebar-btn {\n        font-size: 12px;\n        font-weight: 500;\n        flex-direction: column;\n        justify-content: center;\n        text-align: center;\n        width: auto;\n        flex: 1 1 auto;\n    }\n\n    .sidebar-btn:first-child {\n        flex: 0 0 auto;\n    }\n\n    .sidebar-btn .anticon{\n        display: none;\n    }\n\n    .sidebar-btn:not(:last-child) {\n        margin-bottom: 0;\n    }\n\n    .product-section {\n        flex: 1 1 auto;\n        overflow: auto;\n    }\n\n    .product-section .ant-typography {\n        display: block;\n        width: 100%;\n    }\n\n    .product-section .ant-typography strong {\n        /* text-align: center; */\n        display: block;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
